module.exports = __webpack_public_path__ + "static/media/gold-card.100cfa15.png";